import ConfirmDestructiveDialog from '../../../../common/dialogs/ConfirmDestructiveDialog';

interface UndoMessageConfirmDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const UndoMessageConfirmDialog = ({
  onConfirm,
  onCancel,
}: UndoMessageConfirmDialogProps) => {
  return (
    <ConfirmDestructiveDialog
      open
      title="Undo last change?"
      confirmText="Undo"
      cancelText="Cancel"
      onConfirm={onConfirm}
      onClose={onCancel}
    >
      This will revert the canvas to the previous state.
    </ConfirmDestructiveDialog>
  );
};
